export default Object.freeze({
  SCREENING: 'SCREENING',
  FULL_TEXT_REVIEW: 'FULL_TEXT_REVIEW',
  DATA_EXTRACTION: 'DATA_EXTRACTION',
});
